import store from "../store";
import VueCookies from "vue-cookies";

export default async function guestAuth({ next, to }) {
  if (!store.state.authenticate && !VueCookies.isKey("token")) {
    return next();
  }

  if (!store.state.authenticate) {
    const res = await store.dispatch("checkHasUser");

    if (res === -1) return next();
    if (res.result == 0) return next();
    else if (!res) return next();
  }

  return next("/profile");
}
